import React, {useState} from "react";
import axios from "axios";
import WeatherInfo from "./WeatherInfo";
import WeatherForecast from "./WeatherForecast";
import "./Weather.css";

export default function Weather(props) {

    const [ready, setReady] = useState(false);
    const [weatherData, setWeatherData] = useState({});
    const[city, setCity] = useState(props.defaultCity);
    

    function handleResponse(response) {
        
        setWeatherData({
            coordinates: response.data.coord,
            temperature: response.data.main.temp,
            wind: response.data.wind.speed,
            date: new Date(response.data.dt*1000),
            city: response.data.name,
            humidity: response.data.main.humidity,
            description: response.data.weather[0].description,
            icon:response.data.weather[0].icon});
        
        setReady(true);
    }

    function Search() {
        const apiKey = "c50922829f85c8a60c3d5613f8ba6259";
    
        let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
    
        axios.get(apiUrl).then(handleResponse);
    }
    function handleSubmit(event) {
        event.preventDefault();
        Search();

    }

    function handleCityChange(event) {
        setCity(event.target.value);
    }

    if(ready) {
        
    return(
        <div className = "Weather">
            <form onSubmit={handleSubmit}>
                <div className = "row">
                <div className = "col-9">
                <input type="search" placeholder="Enter a city" className = "form-control" autoFocus="on" onChange={handleCityChange}/>
                </div>
                <div className = "col-3">
                <input type="submit" value="Search" className="btn btn-primary w-100"/></div>
                </div>
            </form>
            <WeatherInfo data={weatherData}/>
            
            <WeatherForecast coordinates={weatherData.coordinates}/>
        </div>
    );

    } else {
    Search();
    return "Loading...";
    }

    
}